import { Radio, Bell, Bot, BookOpen, Coins, Crown, Home, Landmark, LineChart, Medal, Sparkles, Trophy, UserRound, Zap } from "lucide-react";

export const TABS = [
  ["/", "Home", Home, "nav-home"],
  ["/sports", "Sports", Trophy, "nav-sports"],
  ["/predict", "Predict", LineChart, "nav-predict"],
  ["/auto", "Bots", Bot, "nav-auto"],
];

export const SECTIONS = [
  ["1 · Markets", [["/", "Home", Home, "home"], ["/sports", "Sports odds", Trophy, "sports"], ["/predict", "Predict (all markets)", LineChart, "predict"],
    ["/live", "Live markets (15-min & hourly)", Radio, "live"], ["/polymarket", "BTC 15-min deep dive", Zap, "polymarket"], ["/markets", "Coins & watchlist", Coins, "markets"]]],
  ["2 · Trade", [["/accounts", "Linked accounts", Landmark, "accounts"], ["/auto", "Auto-trade bots", Bot, "auto"]]],
  ["3 · Learn & tools", [["ai", "Ask AI", Sparkles, "ai"], ["/learn", "Handbooks", BookOpen, "learn"], ["/alerts", "Price alerts", Bell, "alerts"],
    ["/leaderboard", "Leaderboard", Medal, "leaderboard"]]],
  ["4 · You", [["/account", "Account & mode", UserRound, "account"], ["/pro", "Plans & free trial", Crown, "pro"]]],
];

export const TITLES = {
  "/": "Live Odds, Data Picks & AI", "/predict": "Prediction Markets: Sports, Politics, Crypto", "/sports": "Sports Odds: NFL, College Football, NBA, Soccer",
  "/polymarket": "Bitcoin 15-Minute Up/Down Odds", "/markets": "Crypto Prices & Watchlist", "/alerts": "Price Alerts", "/learn": "Prediction Market Handbooks",
  "/leaderboard": "Weekly Leaderboard", "/account": "Account", "/pro": "Plans: Free, Pro, Elite", "/admin": "Owner Console",
  "/auto": "Auto-Trading Bots", "/live": "Live 15-Minute & Hourly Markets", "/accounts": "Linked Accounts",
};
